import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
@Directive({
  selector: '[appIf]'
})
export class IfDirective {

  constructor(private templateRef: TemplateRef<any>, public viewContainer: ViewContainerRef) { }

  @Input() set appIf(item: any) {
    if (item != null && item.length > 0) {
      const split = item.split('~');
      if (split.length >= 2) {
        // Flag H is hide..
        if (item.split('~')[0] === 'REC_JOB_CVC') {
        }
        if (item.split('~')[1] === 'H') {
          this.viewContainer.clear();
        } else {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      }
    }
  }
}
